
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
 * This file should be your main import to use Prisma. Through it you get access to all the models, enums, and input types.
 * If you're looking for something you can import in the client-side of your application, please refer to the `browser.ts` file instead.
 *
 * 🟢 You can import this file directly.
 */

import * as process from 'node:process'
import * as path from 'node:path'
import { fileURLToPath } from 'node:url'
globalThis['__dirname'] = path.dirname(fileURLToPath(import.meta.url))

import * as runtime from "@prisma/client/runtime/client"
import * as $Enums from "./enums"
import * as $Class from "./internal/class"
import * as Prisma from "./internal/prismaNamespace"

export * as $Enums from './enums'
export * from "./enums"
/**
 * ## Prisma Client
 * 
 * Type-safe database client for TypeScript
 * @example
 * ```
 * const prisma = new PrismaClient({
 *   adapter: new PrismaPg({ connectionString: process.env.DATABASE_URL })
 * })
 * // Fetch zero or more Problems
 * const problems = await prisma.problem.findMany()
 * ```
 * 
 * Read more in our [docs](https://pris.ly/d/client).
 */
export const PrismaClient = $Class.getPrismaClientClass()
export type PrismaClient<LogOpts extends Prisma.LogLevel = never, OmitOpts extends Prisma.PrismaClientOptions["omit"] = Prisma.PrismaClientOptions["omit"], ExtArgs extends runtime.Types.Extensions.InternalArgs = runtime.Types.Extensions.DefaultArgs> = $Class.PrismaClient<LogOpts, OmitOpts, ExtArgs>
export { Prisma }

/**
 * Model Problem
 * 
 */
export type Problem = Prisma.ProblemModel
/**
 * Model ProblemGroup
 * 
 */
export type ProblemGroup = Prisma.ProblemGroupModel
/**
 * Model User
 * 
 */
export type User = Prisma.UserModel
/**
 * Model UserProblemState
 * 
 */
export type UserProblemState = Prisma.UserProblemStateModel
/**
 * Model UserGroupState
 * 
 */
export type UserGroupState = Prisma.UserGroupStateModel
/**
 * Model ReviewLog
 * 
 */
export type ReviewLog = Prisma.ReviewLogModel
/**
 * Model StudySession
 * 
 */
export type StudySession = Prisma.StudySessionModel
